export const formStyles = {
  input: 'w-full px-3 py-2 bg-white border border-[#d4d4d4] rounded-lg text-sm text-[#0a0a0a] focus:outline-none focus:border-[#8a6a2f] transition-colors',
  label: 'block text-xs text-[#737373] mb-1.5 font-medium',
  compactLabel: 'block text-xs text-[#737373] mb-1 font-medium',
  secondaryButton: 'px-4 py-2 text-sm font-medium text-[#525252] bg-white border border-[#d4d4d4] rounded-lg hover:bg-[#f5f5f5] transition-colors',
  primaryButton: 'px-4 py-2 text-sm font-medium text-white bg-[#0a0a0a] rounded-lg hover:bg-[#262626] transition-colors',
};
